import { useForm } from '@mantine/form';

import { TransitViewEditHouseFormValues } from './validateTransitViewEditHouseForm';

export const useTransitViewEditHouseFormInitializer = ({ houseConsignmentIdx, form, onSave, onHide }) => {
  const houseConsignment = form?.values?.Consignment.HouseConsignment ? form?.values?.Consignment.HouseConsignment[houseConsignmentIdx] : null;

  const houseForm = useForm<TransitViewEditHouseFormValues>({
    initialValues: {
      isMissing: houseConsignment?.isMissing || false,
      receivedFromUnloadPermission: houseConsignment?.receivedFromUnloadPermission || false,
      sequenceNumber: houseConsignment?.sequenceNumber || '',
      countryOfDispatch: houseConsignment?.countryOfDispatch || '',
      countryOfDestination: houseConsignment?.countryOfDestination || '',
      grossMass: houseConsignment?.grossMass || '',
      referenceNumberUCR: houseConsignment?.referenceNumberUCR || '',
      Consignor: {
        identificationNumber: houseConsignment?.Consignor?.identificationNumber || '',
        name: houseConsignment?.Consignor?.name || '',
        Address: {
          streetAndNumber: houseConsignment?.Consignor?.Address?.streetAndNumber || '',
          postcode: houseConsignment?.Consignor?.Address?.postcode || '',
          city: houseConsignment?.Consignor?.Address?.city || '',
          country: houseConsignment?.Consignor?.Address?.country || '',
        },
      },
      Consignee: {
        identificationNumber: houseConsignment?.Consignee?.identificationNumber || '',
        name: houseConsignment?.Consignee?.name || '',
        Address: {
          streetAndNumber: houseConsignment?.Consignee?.Address?.streetAndNumber || '',
          postcode: houseConsignment?.Consignee?.Address?.postcode || '',
          city: houseConsignment?.Consignee?.Address?.city || '',
          country: houseConsignment?.Consignee?.Address?.country || '',
        },
      },
      AdditionalSupplyChainActor: (houseConsignment?.AdditionalSupplyChainActor ?? []).map((additionalSupplyChainActor) => ({
        role: additionalSupplyChainActor.role || '',
        identificationNumber: additionalSupplyChainActor.identificationNumber || '',
      })),
      DepartureTransportMeans: (houseConsignment?.DepartureTransportMeans ?? []).map((departureTransportMeans) => ({
        typeOfIdentification: departureTransportMeans.typeOfIdentification || '',
        identificationNumber: departureTransportMeans.identificationNumber || '',
        nationality: departureTransportMeans.nationality || '',
      })),
      documents: {
        PreviousDocument: (houseConsignment?.PreviousDocument || []).map((previousDocument) => ({
          type: previousDocument.type || '',
          referenceNumber: previousDocument.referenceNumber || '',
          complementOfInformation: previousDocument.complementOfInformation || '',
        })),
        SupportingDocument: (houseConsignment?.SupportingDocument || []).map((previousDocument) => ({
          type: previousDocument.type || '',
          referenceNumber: previousDocument.referenceNumber || '',
          documentLineItemNumber: previousDocument.documentLineItemNumber || '',
          complementOfInformation: previousDocument.complementOfInformation || '',
        })),
        TransportDocument: (houseConsignment?.TransportDocument || []).map((previousDocument) => ({
          type: previousDocument.type || '',
          referenceNumber: previousDocument.referenceNumber || '',
        })),
        AdditionalReference: (houseConsignment?.AdditionalReference || []).map((previousDocument) => ({
          type: previousDocument.type || '',
          referenceNumber: previousDocument.referenceNumber || '',
        })),
        AdditionalInformation: (houseConsignment?.AdditionalInformation || []).map((previousDocument) => ({
          code: previousDocument.code || '',
          text: previousDocument.text || '',
        })),
      },
      batches: (houseConsignment?.batches || []).map((batch) => ({
        id: batch.id || '',
        name: batch.name || '',
      })),
    },
  });

  const onSubmit = async () => {
    const values = houseForm.values;
    const data = {
      ...values,
      ...values.documents,
      documents: undefined,
    };

    onSave(data);
    onHide();
  };

  return { houseForm, onSubmit };
};
